import { basicNumberComparator, dateComparator } from "utils/comparatorUtils";
import { formatDate } from "utils/utils.js";
import { getTwoDecimalPoint } from "utils/utils.js";
import { CIPAnalyticsIndexTableStrings } from "constants/constantStrings";
import { LOCAL_TZ_CODE } from "constants/globalConstants";

const valuesColor = params => {
  const { value } = params;
  let color;
  if (value >= 85 && value <= 100) {
    color = "var(--color-dark-green)";
  } else if (value >= 75 && value <= 85) {
    color = "var(--color-orange)";
  } else if (value <= 75) {
    color = "var(--color-red)";
  } else if (value > 100 || value < 0) {
    color = "var(--color-medium-grey)";
  }
  return { color: color };
};
export const getCIPIndexTableColDefs = () => [
  // {
  //   field: 'Display',
  //   headerName: CIPAnalyticsIndexTableStrings.Display,
  //   headerComponentFramework: CIPCleaningTableHeaderCheckboxRenderer,
  //   cellRendererFramework: CIPCleaningTableCheckboxRenderer,
  //   headerCheckboxSelectionFilteredOnly: true,
  //   headerComponentParams: { field: 'Display',CheckboxState },
  //   flex: 1,
  //   minWidth: 100
  // },
  {
    field: "Id",
    headerName: CIPAnalyticsIndexTableStrings.Id,
    minWidth: 80,
    flex: 1,
    editable:false,
    comparator: basicNumberComparator,
    headerClass: "custom-header"
  },
  {
    field: "Start_Time",
    headerName: CIPAnalyticsIndexTableStrings.Start_Time,
    valueFormatter: params => ` ${formatDate(params.data.Start_Time)} ${LOCAL_TZ_CODE}`,
    minWidth: 150,
    flex: 1.5,
    editable:false,
    comparator: dateComparator,
    headerClass: "custom-header"
  },
  {
    field: "End_Time",
    headerName: CIPAnalyticsIndexTableStrings.End_Time,
    valueFormatter: params => `${formatDate(params.data.End_Time)} ${LOCAL_TZ_CODE}`,
    minWidth: 150,
    flex: 1.5,
    editable:false,
    comparator: dateComparator,
    headerClass: "custom-header"
  },
  {
    field: "normalized_differential_pressure_Cleanability_Initial",
    headerName: CIPAnalyticsIndexTableStrings.DP_Cleanability_Initial,
    minWidth: 170,
    flex: 1.5,
    editable:false,
    comparator: basicNumberComparator,
    headerClass: "custom-header",
    cellStyle: valuesColor,
    valueFormatter: params => getTwoDecimalPoint(params.data.normalized_differential_pressure_Cleanability_Initial)
  },
  {
    field: "normalized_permeate_flow_Cleanability_Initial",
    headerName: CIPAnalyticsIndexTableStrings.PF_Cleanability_Initial,
    minWidth: 170,
    flex: 1.5,
    editable:false,
    comparator: basicNumberComparator,
    headerClass: "custom-header",
    cellStyle: valuesColor,
    valueFormatter: params => getTwoDecimalPoint(params.data.normalized_permeate_flow_Cleanability_Initial)
  },
  {
    field: "normalized_salt_passage_Cleanability_Initial",
    headerName: CIPAnalyticsIndexTableStrings.SP_Cleanability_Initial,
    minWidth: 170,
    flex: 1.5,
    editable:false,
    comparator: basicNumberComparator,
    headerClass: "custom-header",
    cellStyle: valuesColor,
    valueFormatter: params => getTwoDecimalPoint(params.data.normalized_salt_passage_Cleanability_Initial)
  }
];
